var render = function render(){var _vm=this,_c=_vm._self._c;return _c('error-page',{attrs:{"textSubtitle":"No estás autorizado para acceder.","listErrorComponent":_vm.listErrorComponents}})
}
var staticRenderFns = []

export { render, staticRenderFns }